import React from 'react';
import classNameBind from 'classnames/bind';
import Icon from '../Icon';
import styles from './DraggableListBlock.module.css';

const bindClasses = classNameBind.bind(styles);

const DraggableListBlock = ({
  inactive,
  setRef,
  extendedArea,
  dropped,
  menu,
  dataId,
  children,
  ...rest
}) => (
  <div
    {...rest}
    ref={setRef}
    className={bindClasses('area', 'no-select', { extendedArea })}
    data-ppuc-id={dataId}
  >
    <div className={bindClasses('fake-dropzone')}>
      <div
        className={
            bindClasses('wrapper', { inactive })
          }
      >
        <Icon
          name="draggable"
          className={bindClasses('icon-dots', 'icon-left')}
          color="gray"
          dataId={`${dataId}.dragIcon`}
        />
        <div className={bindClasses('children')}>
          { children }
        </div>
      </div>
    </div>
  </div>
);

DraggableListBlock.defaultProps = {
  inactive: false,
  setRef: null,
  extendedArea: false,
  dropped: false,
  menu: false,
  dataId: 'DraggableListBlock',
};

export default DraggableListBlock;
